import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import dayjs from "dayjs";
import util from "@/libs/util.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "quarter-statistics",
  data: function data() {
    return {
      date: [],
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        code: this.$route.query.code || "",
        usageType: "",
        discountType: "",
        distributionType: "",
        triggerCondition: "",
        status: "",
        userName: "",
        phone: "",
        issueStartTime: "",
        issueEndTime: ""
      },
      // 搜索表单

      couponTemplateConfig: {},
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0 // 总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getCouponTemplateConfig();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    goOrderList: function goOrderList(row) {
      if (!row.orderId) {
        return;
      }
      if (row.usageType === "HP") {
        window.open("#/order/housing/promotion?id=".concat(row.orderId));
      }
      if (row.usageType === "LM" || row.usageType === "TM") {
        window.open("#/order/member?id=".concat(row.orderId));
      }
      if (row.usageType === "HV") {
        window.open("#/order/housing/certification?id=".concat(row.orderId));
      }
    },
    getCouponTemplateConfig: function getCouponTemplateConfig() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getCouponTemplateConfig();
            case 1:
              res = _context2.v;
              _this2.couponTemplateConfig = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    resetForm: function resetForm() {
      this.date = [];
      this.searchForm = {
        pageNum: 1,
        pageSize: 20,
        code: "",
        usageType: "",
        discountType: "",
        distributionType: "",
        triggerCondition: "",
        status: "",
        userName: "",
        phone: "",
        issueStartTime: "",
        issueEndTime: ""
      };
      this.getData('search');
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _res$data$content;
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pageNum = 1;
              }
              _this3.searchForm.issueStartTime = _this3.date[0] ? parseInt(_this3.date[0] / 1000) : "";
              _this3.searchForm.issueEndTime = _this3.date[1] ? parseInt(_this3.date[1] / 1000) : "";
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getCouponRecordList(_this3.searchForm);
            case 1:
              res = _context3.v;
              (_res$data$content = res.data.content) === null || _res$data$content === void 0 || _res$data$content.forEach(function (item) {
                item.createTime = dayjs(item.createTime * 1000).format("YYYY-MM-DD HH:mm");
              });
              _this3.tableData = res.data.content;
              _this3.total = res.data.totalSize;
              _this3.tableLoading = false;
              _this3.getUserListByIds(_this3.tableData, "userId");
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};